import Linkedin from "assets/linkedin2.png";
import Instagram from "assets/instagram.png";
import Youtube from "assets/youtube.png";
import Teltec from "assets/teltecsolutions.png";
import { SignatureIcon } from "../SignatureIcon/SignatureIcon";
import { StyledTr } from "./SignatureIcons.styles";

export const SignatureIcons = () => {
  return (
    <table style={{ marginLeft: "auto" }}>
      <tbody>
        <StyledTr>
          <SignatureIcon
            alt="Teltec Solutions Linkedin"
            url="https://www.linkedin.com/company/teltec-solutions"
            img={Linkedin}
          ></SignatureIcon>
        </StyledTr>
        <StyledTr>
          <SignatureIcon
            alt="Teltec Solutions Instagram"
            url="https://www.instagram.com/teltecsolutions"
            img={Instagram}
          ></SignatureIcon>
        </StyledTr>
        <StyledTr>
          <SignatureIcon
            alt="Teltec Solutions YouTube"
            url="https://www.youtube.com/@teltecsolutions"
            img={Youtube}
          ></SignatureIcon>
        </StyledTr>
        <StyledTr>
          <SignatureIcon
            alt="Teltec Solutions Website"
            url="https://www.teltecsolutions.com.br/"
            img={Teltec}
          ></SignatureIcon>
        </StyledTr>
      </tbody>
    </table>
  );
};
